import React, { useEffect, useState } from 'react';
import { Icon, Menu, MenuItem, Typography, ListItemIcon, Popover, Popper } from '@mui/material';
import { size, get, set } from 'global/lib/lodash';
import { useStyles } from './styles';
import { Button as OurButton } from '../Button';
import { guid, stopProp } from '../../utils';
import colors from '../../styles/colors';

export const MoreDrop = (props) => {
  const { options } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (e, opt) => {
    setAnchorEl(null);
    opt.onClick && opt.onClick(e);
  };

  if (!size(options)) {
    return null;
  }

  return (
    <>
      <OurButton variant="none" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
        <Icon style={{ color: colors.black }}>more_vert</Icon>
      </OurButton>
      <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {(options || []).map((opt, i) => {
          return (
            <MenuItem key={i} onClick={(e) => handleClose(e, opt)}>
              {opt.icon && (
                <ListItemIcon className={classes.listItemIcon}>
                  <Icon>{opt.icon}</Icon>
                </ListItemIcon>
              )}

              <Typography variant="inherit">{opt.title}</Typography>
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

const POPPERS = {};
const ELEMENTID = 'simple-popover';

export const MoreList = (props) => {
  const { options, icon, title } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [key] = useState(guid());
  const classes = useStyles();

  const type = get(props, 'type', 'radio');

  const open = Boolean(anchorEl);

  const id = open ? ELEMENTID : undefined;

  const handleClick = (event) => {
    stopProp(event);
    if (!open) {
      Object.keys(POPPERS).map((k) => {
        const pop = POPPERS[k];
        pop && pop.forceClose && pop.forceClose();
      });
    }
    setAnchorEl(open ? undefined : event.currentTarget);
  };

  const forceClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    if (open) {
      props.onOpen && props.onOpen();
    } else {
      props.onClose && props.onClose();
    }
  }, [open]);

  useEffect(() => {
    set(POPPERS, key, { forceClose });
    return () => {
      set(POPPERS, key, undefined);
    };
  }, []);

  const handleClose = (e, opt) => {
    opt && opt.onClick && opt.onClick(e);
    if (opt && type === 'checkbox') {
      return;
    }
    onClose(e);
  };

  const onClose = (e) => {
    if (!props.preventClose) {
      setAnchorEl(null);
    }
  };

  if (!size(options)) {
    return null;
  }

  const getIcon = (opt) => {
    if (type === 'checkbox') {
      return <Icon>{opt.selected ? 'check_box' : 'check_box_outline_blank'}</Icon>;
    } else {
      return <Icon>{opt.selected ? 'radio_button_checked' : 'radio_button_unchecked'}</Icon>;
    }
  };

  const ELEM = props.preventClose ? Popper : Popover;

  const buttonProps = get(props, 'buttonProps', {});

  const showIcon = get(props, 'showIcon', true);

  return (
    <>
      <OurButton bgColor={props.bgColor} aria-controls="simple-menu" disableElevation variant="contained" size="small" aria-haspopup="true" onClick={handleClick} {...buttonProps}>
        {props.renderButton ? props.renderButton() : <Icon>{icon || 'more_vert'}</Icon>}
      </OurButton>
      <ELEM id={id} anchorEl={anchorEl} open={open} onClose={onClose} className={props.preventClose ? classes.popper : undefined}>
        {!!title && (
          <div onClick={handleClick} className={classes.title}>
            {title}
          </div>
        )}

        {(options || []).map((opt, i) => {
          return (
            <MenuItem {...opt} key={i} onClick={(e) => handleClose(e, opt)}>
              {showIcon && <ListItemIcon className={classes.listItemIcon}>{getIcon(opt)}</ListItemIcon>}

              <Typography variant="inherit">{opt.title}</Typography>
            </MenuItem>
          );
        })}
      </ELEM>
    </>
  );
};